import { Component, OnInit, NgZone, OnDestroy } from '@angular/core';
import { MessageServerService } from '../../../services/hub-services/message-server/message-server.service';
import { MenuService } from '../../../services/menu.service';
import { CallerPatient } from '../../../model/caller-patient';
import { ActivatedRoute } from '@angular/router';
import { AdmissionService } from '../../../services/admission.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { ResizedEvent } from 'angular-resize-event';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-caller-patient',
  templateUrl: './caller-patient.component.html',
  styleUrls: ['./caller-patient.component.css']
})
export class CallerPatientComponent implements OnInit {
 
  interval: any;
  loaded: boolean = false;
  isLaunched: boolean = false;

  constructor( private messageServerService: MessageServerService,
                menuService: MenuService  ) {
    
    menuService.hideMenu();
  
  }

  init() {
    this.isLaunched = true;
    this.interval = setInterval(() => {
      if (!this.loaded) {
          this.loaded = this.messageServerService.connectionExists;
      } else {
        clearInterval(this.interval);
      }
    }, 1000);
   
  }
 
  ngOnInit() {

  
    
  } 
}
